import { Row, Col, Icon, Popover, Collapse, Tag } from "antd";
import moment from "moment";
import React from "react";

import GraphConst from "../../../constants/graph";

const Panel = Collapse.Panel;
const { RISK } = GraphConst;

const IndividualStressTestUser = (props) => {
	const { value: { date, level, provider }, isProvider } = props;
	return (
		<div>
			{
				isProvider ?
					<CollapseStressTest {...props} /> :
					<StressTestInfo style={{ marginBottom: 10 }} {...props} />
			}
		</div>
	);
};

const CollapseStressTest = (props) => {
	const { value: { provider: { provider, tag } } } = props;
	return (
		<Collapse bordered={false}>
			<Panel header={<StressTestInfo {...props} />}>
				<Row>
					<Col span={15}>
						{
							tag.map((value, index) =>
								<Tag key={index} color="#00c4b3" style={{ marginBottom: 3 }}>{value}</Tag>)
						}
					</Col>
					<Col span={9}>
						<Icon type="user" style={{ marginRight: 10 }} />
						<span>{provider}</span>
					</Col>
				</Row>
			</Panel>
		</Collapse>
	);
};

const StressTestInfo = ({ value: { start, end, level, provider }, id, isProvider, style }) => {
	const { color, short, description } = RISK[level];
	const a = moment.unix(start);
	const b = moment.unix(end);
	const duration = b.diff(a, "minutes");
	// var hours = duration.asMinutes();
	// const duration = moment.utc(moment(b, "DD/MM/YYYY HH:mm:ss")
	//     .diff(moment(a, "DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
	// const isProvider = provider ? true : false
	return (
		<Row style={{ ...style }}>
			<Col span={isProvider ? 9 : 12}>
				<span style={{ marginRight: 5, fontSize: 14 }}>{`${id}.`}</span>
				<span style={{ fontSize: 12 }}>{moment.unix(start).format("MM/DD/YYYY")}</span>
			</Col>
			{
				isProvider ?
					<Col span={6}>
						<span style={{ fontSize: 12 }}>{`${duration} min`}</span>
					</Col> : null
			}
			<Col span={isProvider ? 9 : 12}>
				<span style={{ marginRight: 5, fontSize: 14 }}>{`Level ${level + 1}:`}</span>
				<span style={{ marginRight: 3, fontSize: 12, color }}>{short}</span>
				<Popover placement="bottom" content={<div>
					<p style={{ color, fontSize: 12 }}>{`Level ${level + 1}`}</p>
					<p style={{ color, fontSize: 10 }}>{description}</p>
				</div>}>
					<Icon type="question-circle" style={{ color }} />
				</Popover>
			</Col>
		</Row>
	);
};

export default IndividualStressTestUser;


// WEBPACK FOOTER //
// ./src/components/report/individual_user/IndividualStressTestUser.js